import { Stage } from "../helpers/get-settings";

export type QueryParam = string | string[] | undefined;

export interface UrlProps {
  stage?: Stage;
  requisitionId?: QueryParam;
  applicationId?: QueryParam;
  candidateId?: QueryParam;
  sfCandidateId?: QueryParam;
  redirectUrl?: QueryParam;
  scheduleId?: QueryParam;
  cssPage?: QueryParam;
}

// ---------------- API ---------------------------
export const BADGE_PHOTO_URL = "/api/badgephotos";
export const VIDEO_API_URL = "/api/video/:applicationId";
export const METRIC_API_URL = "/api/metric/";
export const VIDEO_RECORD_API_URL = "/api/video-record/:applicationId";
export const VIDEO_RECORD_NON_ASH_API_URL =
  "/api/video-record/non-ash/:requisitionId/:candidateId";
export const CAAS_API_URL = "/api/caas/:sfCandidateId?redirectUrl=:redirectUrl";
export const SDA_API_URL = "/api/sda/:applicationId";
export const JC_API_URL = "/api/jobcontainer/schedule/:applicationId/en-US";
export const SF_STEP_API_URL = "/api/status/step/application/:applicationId";
export const SF_NHE_STATUS_API_URL =
  "/api/status/nhe-status/application/:applicationId";

// ---------------- Internal pages ----------------
export const CHECKLIST_URL = "/checklist/:requisitionId/:applicationId";
export const NEW_HIRE_VIDEO_URL =
  "/checklist/tasks/new-hire-video/:requisitionId/:applicationId";
export const TAKE_BADGE_PHOTO_START_URL =
  "/checklist/tasks/badge/:requisitionId/:applicationId/start";
export const TAKE_BADGE_PHOTO_CAMERA_GALLERY_URL =
  "/checklist/tasks/badge/:requisitionId/:applicationId/camera/gallery";
export const TAKE_BADGE_PHOTO_CAMERA_REQUIREMENTS_URL =
  "/checklist/tasks/badge/:requisitionId/:applicationId/camera/requirements";
export const TAKE_BADGE_PHOTO_CAMERA_URL =
  "/checklist/tasks/badge/:requisitionId/:applicationId/camera";
export const TAKE_BADGE_PHOTO_UPLOAD_REQUIREMENTS_URL =
  "/checklist/tasks/badge/:requisitionId/:applicationId/upload/requirements";
export const TAKE_BADGE_PHOTO_UPLOAD_URL =
  "/checklist/tasks/badge/:requisitionId/:applicationId/upload";
export const TAKE_BADGE_PHOTO_CONFIRM_URL =
  "/checklist/tasks/badge/:requisitionId/:applicationId/confirm";
export const TAKE_BADGE_PHOTO_RESULT_URL =
  "/checklist/tasks/badge/:requisitionId/:applicationId/result";
export const BB_APPLICATION_ENDPOINT = "/api/bb/candidate/:applicationId";
export const BB_NHE_APPOINTMENT_ENDPOINT =
  "/api/bb/nhe-appointment/:applicationId";
export const BACKGROUND_CHECK_STATUS_ENDPOINT =
  "/api/status/background-check/candidate/:candidateId";
export const DRUG_TEST_STATUS_ENDPOINT =
  "/api/status/drug-test/candidate/:sfCandidateId";
export const PERSONAL_INFORMATION_COLLECTION_URL =
  "/checklist/tasks/pic/:requisitionId/:applicationId/poc";
export const BADGE_PHOTO_STATUS_ENDPOINT =
  "/api/status/badge-photo/candidate/:candidateId";
export const NEW_HIRE_VIDEO_STATUS_ENDPOINT =
  "/api/status/video/application/:applicationId";
export const TASKSTATUS_ENDPOINT = "/api/taskstatus/:sfCandidateId";

// ---------------- External links ----------------
export const USCIS_URL =
  "https://www.uscis.gov/i-9-central/form-i-9-acceptable-documents";
export const I9_ADVANTAGE_URL =
  "https://hr.i9advantage.com/section1/email/confirm_request.aspx?id=125";
export const I9_INSTRUCTIONS_URL =
  "https://formi9.s3-us-west-2.amazonaws.com/Form-I-9-Instructions/index.html#/lessons/-cLWLtxRjIaerEjxaMOm5cSIbKepwQP4";
export const SF_DASHBOARD_URL: Record<Stage, string> = {
  local: "https://bbdev-amazon.cs125.force.com/?isBB=true",
  alpha: "https://bbdev-amazon.cs125.force.com/?isBB=true",
  beta: "https://bbdev-amazon.cs125.force.com/?isBB=true",
  gamma: "https://uat-amazon.cs19.force.com/?isBB=true",
  prod: "https://amazon.force.com/?isBB=true",
};
export const BB_APPOINTMENT_DETAIL_PAGE_URL: Record<Stage, string> = {
  local:
    "https://beta-us.devo.jobsatamazon.hvh.a2z.com/application/?page=appointment-detail-page&requisitionId={requisitionId}&applicationId={applicationId}",
  alpha:
    "https://beta-us.devo.jobsatamazon.hvh.a2z.com/application/?page=appointment-detail-page&requisitionId={requisitionId}&applicationId={applicationId}",
  beta:
    "https://beta-us.devo.jobsatamazon.hvh.a2z.com/application/?page=appointment-detail-page&requisitionId={requisitionId}&applicationId={applicationId}",
  gamma:
    "https://gamma-us.devo.jobsatamazon.hvh.a2z.com/application/?page=appointment-detail-page&requisitionId={requisitionId}&applicationId={applicationId}",
  prod:
    "https://hiring.amazon.com/application/?page=appointment-detail-page&requisitionId={requisitionId}&applicationId={applicationId}",
};

export const CSS_PAGE_URL: Record<Stage, string> = {
  local:
    "https://beta-us.devo.jobsatamazon.hvh.a2z.com/application/?page={cssPage}&jobId={requisitionId}&applicationId={applicationId}&source=ASH",
  alpha:
    "https://beta-us.devo.jobsatamazon.hvh.a2z.com/application/?page={cssPage}&jobId={requisitionId}&applicationId={applicationId}&source=ASH",
  beta:
    "https://beta-us.devo.jobsatamazon.hvh.a2z.com/application/?page={cssPage}&jobId={requisitionId}&applicationId={applicationId}&source=ASH",
  gamma:
    "https://gamma-us.devo.jobsatamazon.hvh.a2z.com/application/?page={cssPage}&jobId={requisitionId}&applicationId={applicationId}&source=ASH",
  prod:
    "https://hiring.amazon.com/application/?page={cssPage}&jobId={requisitionId}&applicationId={applicationId}&source=ASH",
};

export const ADOBE_DATA_LAYER_URL = {
  local:
    "https://assets.adobedtm.com/launch-EN2c38d445ba884f1ca9901284481b2c7b-staging.min.js",
  alpha:
    "https://assets.adobedtm.com/launch-EN2c38d445ba884f1ca9901284481b2c7b-staging.min.js",
  beta:
    "https://assets.adobedtm.com/launch-EN2c38d445ba884f1ca9901284481b2c7b-staging.min.js",
  gamma:
    "https://assets.adobedtm.com/launch-EN2c38d445ba884f1ca9901284481b2c7b-staging.min.js",
  prod:
    "https://assets.adobedtm.com/launch-EN6bc43e7eee5146beaa43d868366aabe6.min.js",
};

const KNOWN_PARAMETERS = [
  "requisitionId",
  "applicationId",
  "candidateId",
  "sfCandidateId",
  "redirectUrl",
  "scheduleId",
  "cssPage",
];

export const buildUrl = (
  url: string | Record<Stage, string>,
  { stage, ...params }: UrlProps
): string => {
  const href = typeof url === "string" ? url : url[stage || ("local" as Stage)];
  return KNOWN_PARAMETERS.reduce((acc, paramName) => {
    const value = (params as any)[paramName];
    if (!value) {
      return acc;
    }
    return acc.replace(`:${paramName}`, value).replace(`{${paramName}}`, value);
  }, href);
};
